// extracted by mini-css-extract-plugin
export default {"BankDetails":"BankDetails_BankDetails__TdILV","BankDetailsTopTitle":"BankDetails_BankDetailsTopTitle__jbg41","BankDetailsWrapper":"BankDetails_BankDetailsWrapper__F4RPW"};